import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

function colorToCssVariables(
  code: string,
  hsl: {
    hue: number;
    saturation: number;
    light: number;
  }
) {
  return {
    [`--hsl-${code}-h`]: hsl.hue,
    [`--hsl-${code}-s`]: `${hsl.saturation}%`,
    [`--hsl-${code}-l`]: `${hsl.light}%`
  };
}

function buildCssColorVariables() {
  const red = { hue: 358, saturation: 78, light: 50 };
  const blue = { hue: 201, saturation: 94, light: 50 };
  const green = { hue: 109, saturation: 40, light: 46 };
  const grey = { hue: 248, saturation: 9, light: 66 };
  const white = { hue: 0, saturation: 0, light: 100 };
  const yellow = { hue: 47, saturation: 100, light: 52 };

  return {
    ...colorToCssVariables('primary', red),
    ...colorToCssVariables('accent', blue),

    ...colorToCssVariables('red', red),
    ...colorToCssVariables('blue', blue),
    ...colorToCssVariables('green', green),
    ...colorToCssVariables('yellow', yellow),
    ...colorToCssVariables('grey', grey),
    ...colorToCssVariables('white', white)
  };
}

@Injectable({
  providedIn: 'root'
})
export class PlatformThemeResolver {
  private renderer: Renderer2;

  private variableMap = buildCssColorVariables();

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  resolve() {
    const rootElement: any = this.document.querySelector(':root');

    /**
     * Renderer is not working within resolver properly
     * this.renderer.setStyle(rootElement, '--my-color3', 'red');
     * better solution should be find
     */
    Object.entries(this.variableMap).forEach(
      ([
        key,
        value
      ]) => {
        rootElement?.style.setProperty(key, value);
      }
    );

    return 'PLATFORM';
  }
}
